import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Route, Switch} from 'react-router';
import {withRouter} from 'react-router-dom';

// Material UI
import { withStyles } from 'material-ui/styles';

// Styles
import styles from './styles';

// Core Scenes
import Start from '../../scenes/Start';
import Notifications from '../../scenes/Notifications';
import Results from '../../scenes/Results';
import Question1 from '../../scenes/Question1';
import Question2 from '../../scenes/Question2';
import Question3 from '../../scenes/Question3';
import Question4 from '../../scenes/Question4';
import Question5 from '../../scenes/Question5';
import Question6 from '../../scenes/Question6';

// Distribution
import Q2 from '../../scenes/Distribution/Q2';
import Q3 from '../../scenes/Distribution/Q3';
import Q4 from '../../scenes/Distribution/Q4';
import Q5 from '../../scenes/Distribution/Q5';
import Q6 from '../../scenes/Distribution/Q6';

class CoreLayout extends Component {
  render(){
    const { classes, location} = this.props;
    return(
      <div className={classes.root}>
        <ConnectedSwitch>
          <Route exact path='/console/display/adhoc_filters/' location={this.props.location} component={Start}/>
          <Route path='/console/display/adhoc_filters/notifications' location={this.props.location} component={Notifications}/>
          <Route path='/console/display/adhoc_filters/results' location={this.props.location} component={Results}/>
          <Route path='/console/display/adhoc_filters/question1' location={this.props.location} component={Question1}/>
          <Route path='/console/display/adhoc_filters/question2' location={this.props.location} component={Question2}/>
          <Route path='/console/display/adhoc_filters/question3' location={this.props.location} component={Question3}/>
          <Route path='/console/display/adhoc_filters/question4' location={this.props.location} component={Question4}/>
          <Route path='/console/display/adhoc_filters/question5' location={this.props.location} component={Question5}/>
          <Route path='/console/display/adhoc_filters/question6' location={this.props.location} component={Question6}/>
          <Route path='/console/display/adhoc_filters/distribution_2' location={this.props.location} component={Q2}/>
          <Route path='/console/display/adhoc_filters/distribution_3' location={this.props.location} component={Q3}/>
          <Route path='/console/display/adhoc_filters/distribution_4' location={this.props.location} component={Q4}/>
          <Route path='/console/display/adhoc_filters/distribution_5' location={this.props.location} component={Q5}/>
          <Route path='/console/display/adhoc_filters/distribution_6' location={this.props.location} component={Q6}/>
        </ConnectedSwitch>
      </div>
    );
  }
}

CoreLayout.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const ConnectedSwitch = connect(state => ({
  location: state.location
}))(Switch)

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
    };
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps)(CoreLayout)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Home/scenes/Adhoc/components/CoreLayout/index.js